/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-13 10:31:49
 * @LastEditors: dengyao
 * @LastEditTime: 2024-09-13 11:25:23
 */
import { Router } from 'vue-router'
import { useSettingStore, useTabStore, useAuthStore } from '@/store'
import isObject from 'lodash/isObject'
import { restructureMeta } from '@/utils'
import { getVersion, versionCheck } from '@/utils/checkVersion'
getVersion() // 触发页面监听

/** 处理菜单选中状态 */
function setMenuStatus(this: any, findMenu: { id: number }) {
  if (!isObject(findMenu)) return
  this.setSelectedKeys([findMenu.id])
}

//获取url所在对象
const getItemByUrl = (list: any[], url: string | number) => {
  // return flatMenus.find((_) => _.menuUrl === url)
  const newArray: any[] = []
  Array.isArray(list) &&
    list.forEach((_) => {
      Array.isArray(_.childs) &&
        _.childs.forEach((v: any) => {
          newArray.push(v)
        })
    })

  return newArray.find((item) => {
    return item.path === url
  })
}

const routerBefore = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    /** 版本检查 */
    versionCheck()
    const [settingStore, tabStore, authStore] = [useSettingStore(), useTabStore(), useAuthStore()]
    if (to.name !== 'Login') {
      const findMenu = getItemByUrl(authStore.menuList, to.path)
      const hasPermission = isObject(findMenu)

      if (!authStore.isLoggedIn) {
        next({ name: 'Login' })
      } else if (!hasPermission && to.meta.requiresAuth) {
        console.log(123)
        //需要认证，无权限的
        to.name !== 'NoAuth' ? next({ name: 'NoAuth' }) : next()
      } else {
        /**  */
        const findMenu = getItemByUrl(authStore.menuList, to.path)
        //处理菜单选中状态
        setMenuStatus.call(settingStore, findMenu)
        tabStore.setTabs({ name: to.name as string, path: to.fullPath, meta: restructureMeta(to) })
        next()
      }
    } else {
      next()
    }
  })
}

export default routerBefore
